module.exports = __webpack_public_path__ + "static/img/img22.dbb544c5.png";